import cls from 'classnames';
import { FC } from 'react';
import styles from './index.module.scss';

export interface IProps {
  active?: boolean;
}

export const Arrow: FC<IProps> = (props) => {
  return (
    <div
      className={cls(styles.arrow, { [styles.active]: !!props?.active })}
    ></div>
  );
};
